// Angular
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

// Local library
import { DepositPayNearMeService } from '@amwager/funding/data-access';

@Component({
  selector: 'feature-mat-pay-near-me',
  templateUrl: './pay-near-me.component.html',
  styleUrls: ['./pay-near-me.component.scss'],
  standalone: true,
  providers: [DepositPayNearMeService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PayNearMeComponent implements OnInit {

  constructor(
    private readonly payNearMeService: DepositPayNearMeService,
  ) { }

  ngOnInit() {
    null;
  }

  openLink(): void {
    // OLD (moved to DepositPayNearMeService.openLink):
    // this.fundingService.openPayNearMe();
    this.payNearMeService.openLink();
  }

}
